import React from 'react';
import { Field } from 'formik';
import { defineMessages, useIntl } from 'react-intl';
import { InputTextComponent, TextAreaComponent } from '../../components/prime-formik';

const i18nMessages = defineMessages({
  dimensionCode: {
    id: 'menu.item-bank-management.dimension-code',
    defaultMessage: 'Dimension Code',
  },
  dimensionDisplayName: {
    id: 'menu.item-bank-management.dimension-display-name',
    defaultMessage: 'Dimension Display Name',
  },
  dimensionDescription: {
    id: 'menu.item-bank-management.dimension-description',
    defaultMessage: 'Dimension Description',
  },
});

const DimensionBasicData = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="dimension-basic-data-form-controls">
      <div>
        <div className="input-label">{formatMessage(i18nMessages.dimensionCode)}</div>
        <div>
          <Field id="code" name="code" component={InputTextComponent} />
        </div>
      </div>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.dimensionDisplayName)}</div>
        <div>
          <Field id="displayName" name="displayName" component={InputTextComponent} />
        </div>
      </div>
      <div>
        <div className="input-label">{formatMessage(i18nMessages.dimensionDescription)}</div>
        <div>
          <Field id="description" name="description" component={TextAreaComponent} />
        </div>
      </div>
    </div>
  );
};

export default DimensionBasicData;
